export enum NavbarActions {
  GO_HOME = 'go_home',
  LOGOUT = 'logout',
  TOGGLE_VOLUME = 'toggle_volume',
  SELECT_USB_DEVICE = 'select_usb_device',
  OPEN_LANGUAGES = 'open_languages',
  DOWNLOAD_PRIOR_YEAR_DAILY_ACTIVITY = 'download_prior_year_daily_activity',
}
